import React, {useRef} from "react";
import "./HowItWorksSection.css";
import {useTrackOnView} from "../../analytics/useTrackOnView";

const steps = [
    {
        number: "1",
        title: "Advertisers fund campaigns",
        description: "Set CPC + budget + target link.",
        trapezoid: "/assets/images/how-it-works/trapezoid-1.svg",
    },
    {
        number: "2",
        title: "Promoters share & earn",
        description: "Unique link + tracked clicks.",
        trapezoid: "/assets/images/how-it-works/trapezoid-2.svg",
    },
    {
        number: "3",
        title: "Partners grow the network",
        description: "Earn from subscriptions + advertiser spend.",
        trapezoid: "/assets/images/how-it-works/trapezoid-1.svg",
    },
];

const HowItWorksSection: React.FC = () => {
    const sectionRef = useRef<HTMLElement>(null);
    useTrackOnView(sectionRef, 'landing_how_it_works_section_viewed', {section_name: 'how_it_works'});

    return (
    <section ref={sectionRef} id="how-it-works" className="py-20 bg-white">
        <div className="container mx-auto text-center mb-12">
      <span className="inline-block text-xs bg-primary/10 text-[#1677ff] px-3 py-3">
        How it works
      </span>
            <h2 className="text-3xl font-medium mt-3">3 simple steps</h2>
        </div>

        <div className="container mx-auto how-steps">
            <img
                className="how-path how-path-left hidden md:block"
                src="/assets/images/how-it-works/path-left.svg"
                alt=""
                aria-hidden="true"
            />
            <img
                className="how-path how-path-right hidden md:block"
                src="/assets/images/how-it-works/path-right.svg"
                alt=""
                aria-hidden="true"
            />

            <div className="grid md:grid-cols-3 gap-12">
                {steps.map((s) => (
                    <div key={s.number} className="text-center px-6">
                        <div className="how-badge">
                            <img src={s.trapezoid} alt="" aria-hidden="true" />
                            <span className="how-badge-num">{s.number}</span>
                        </div>

                        <h4 className="text-xl font-semibold mt-6">{s.title}</h4>
                        <p className="text-gray-600 mt-2">{s.description}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
    );
};

export default HowItWorksSection;
